export const useDataStore = defineStore("data", () => {
  const getDistinctValues = async (model: string, field: string, queryParameters?: Record<string, unknown>): Promise<Array<string>> => {
    const query = getUrlSearchParams(queryParameters)
    const result = await useSamApi<Array<string>>(`/data/${model}/${field}/distinct?${query}`)
    return result.data
  }

  const getDistinctValuesWithCount = async (
    model: string,
    field: string,
    queryParameters?: Record<string, unknown>,
  ): Promise<Array<CountAggregate>> => {
    const query = getUrlSearchParams(queryParameters)
    const result = await useSamApi<Array<CountAggregate>>(`/data/${model}/${field}/distinct-count?${query}`)
    return result.data
  }

  const getLookupValues = async (
    model: string,
    field: string,
    queryParameters?: Record<string, unknown>,
  ): Promise<Array<{ _id: string; [key: string]: string }>> => {
    const query = getUrlSearchParams(queryParameters)
    const result = await useSamApi<Array<{ _id: string; [key: string]: string }>>(`/data/${model}/${field}/lookup?${query}`)
    return result.data
  }

  const getDimensionValues = async (
    model: string,
    field: string,
    queryParameters?: Record<string, unknown>,
  ): Promise<DataTableNumberDimensions> => {
    const query = getUrlSearchParams(queryParameters)
    const result = await useSamApi<DataTableNumberDimensions>(`/data/${model}/${field}/dimensions?${query}`)
    return result.data
  }

  return {
    getDistinctValues,
    getDimensionValues,
    getDistinctValuesWithCount,
    getLookupValues,
  }
})
